import { render, staticRenderFns } from "./EditSupportMessage.vue?vue&type=template&id=6393d856&"
import script from "./EditSupportMessage.vue?vue&type=script&lang=js&"
export * from "./EditSupportMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports